import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../../supabaseClient';
import { AuthContext } from '../../context/AuthContext.jsx';

const ProtectedClientRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  const [isAllowed, setIsAllowed] = useState(null);

  useEffect(() => {
    if (!user) return;

    console.log('AuthContext user:', user); // Debug log

    const checkRole = async () => {
      console.log('Checking role for user:', user?.id); // Debug log

      const { data, error } = await supabase
        .from('users')
        .select('user_type')
        .eq('id', user.id)
        .single();

      if (error || !data) {
        setIsAllowed(false);
      } else if (data.user_type === 'client' || data.user_type === 'super-admin') {
        setIsAllowed(true);
      } else {
        setIsAllowed(false);
      }
    };

    checkRole();
  }, [user]);

  if (isAllowed === null) return null; // or a spinner/loading indicator
  if (!isAllowed) return <Navigate to="/client-login" replace />;

  return children;
};

export default ProtectedClientRoute;